import { render, staticRenderFns } from "./Compensation_fund.vue?vue&type=template&id=d8f7d73c&lang=pug&"
import script from "./Compensation_fund.vue?vue&type=script&lang=js&"
export * from "./Compensation_fund.vue?vue&type=script&lang=js&"
import style0 from "./Compensation_fund.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Compensation_fund.vue"
export default component.exports